import React from 'react';
import CatalogoVirtual from './CatalogoVirtual';

const CatalogoVirtualPage = () => {
  // Quando o usuário clicar em Voltar dentro do catálogo, pedir ao Dashboard para mostrar a aba 'qualidade'
  const handleClose = () => {
    try {
      localStorage.setItem('formularioAtivo', 'qualidade');
      window.dispatchEvent(new CustomEvent('setDashboardTab', { detail: { tab: 'qualidade' } }));
    } catch (e) {
      // fallback: tente recarregar
      window.location.reload();
    }
  };

  // Renderiza o catálogo em tela cheia (sem modal)
  return <CatalogoVirtual fullPage onClose={handleClose} />;
};

export default CatalogoVirtualPage;
